export class Pesquisa
{
    produto: string;
    uf: string;
    cidade: string;
    bairro: string;
    areaAtuacao: string;
    CRO: string;
    nome: string;

    somenteEspecialistas: boolean;
    somenteEmergencia: boolean;
    somente24horas: boolean;
    isRedeNacional: boolean;

    registroANS: string;

    skip: number;
    take: number;
    modo: string;


    constructor() {

        this.produto = '';
        this.uf = '';
        this.cidade = '';
        this.bairro = '',
        this.areaAtuacao = '';
        this.CRO = '';
        this.nome = '';
        this.somenteEspecialistas = false;
        this.somenteEmergencia = false;
        this.somente24horas = false;
        this.isRedeNacional = false;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pesquisa/pesquisa.ts
 **/